import React, { useEffect } from 'react';
import '../../../styles/mainContents.css'
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import MainHeader from '../../layout/MainHeader';
import UsersRole from './UsersRole';

function UserManagement(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const { authreducerState } = props;

  return (

    <div className="mainCN">
      <main className='MainPageCN'>

        <div>      
          {/* TODO: MOVE CHECK ISLOGGEDIN */}
          {!authreducerState.isLoggedIn ? (

            <React.Fragment>              
              {history.push('/login')}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <MainHeader pageTitle=""/>           
            </React.Fragment>
          )}          

          <table className='landingPageTbl'>
            <thead>
              <tr></tr>
            </thead>
            <tbody>            
              <tr>
                <td>
                  {/* <Transfer/> */}
                  <UsersRole/>
                </td>
                <td>
                  {/* <Orders/> */}
                </td>
              </tr>
            </tbody>
            
          </table>        
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("UserManagement() mapStateToProps state: " + JSON.stringify(state));

 return {
  authreducerState: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);